import useEffectOnce from '@rio-cloud/rio-uikit/useEffectOnce';
import { connect } from 'react-redux';

import type { Dispatch, State } from '../../types';
import { fetchGeoBooked } from '../actions/bookingsActions';
import { NoProductBooking } from '../app/NoProductBooking';
import POIAdministration from '../legacy/components/PoiAdministration';
import { hasGeoBooking, isLoadingBookings } from '../reducers/selectors';

interface PoiPageProps {
    hasAccess: boolean;
    isLoading: boolean;
    fetchGeoBooked: () => void;
}

export function POIPage(props: PoiPageProps) {
    const { fetchGeoBooked, isLoading, hasAccess } = props;

    useEffectOnce(() => {
        fetchGeoBooked();
    });

    if (isLoading) {
        return null;
    }
    return <div className={'module-content'}>{hasAccess ? <POIAdministration /> : <NoProductBooking />}</div>;
}

export const mapStateToProps = (state: State) => ({
    hasAccess: hasGeoBooking(state),
    isLoading: isLoadingBookings(state),
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchGeoBooked: () => {
        dispatch(fetchGeoBooked());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(POIPage);
